import classNames from "classnames";
import { Icon } from "PFComponents/icon";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./pagination.module.scss";

const Pagination = ({ page, perPage, total, onClick, className }) => {
  const { t } = useTranslation("workflow");

  const from = perPage * (page - 1) + 1;
  const to = perPage * page > total ? total : perPage * page;
  const totalPages = Math.max(Math.ceil(total / perPage), 1);

  if (!total || !page || !perPage) {
    return null;
  }

  return (
    <div className={classNames(css.container, className)}>
      <span>{t("parts.fromToOfTotal", { from, to, total })}</span>

      <button
        className={classNames(css.button, css.leftButton)}
        disabled={page === 1}
        kind="blank"
        onClick={() => onClick(page - 1)}
      >
        <Icon name="chevron-left" size="sm" />
      </button>
      <button
        style={{ marginLeft: 0 }}
        className={classNames(css.button, css.rightButton)}
        disabled={page === totalPages}
        kind="blank"
        onClick={() => onClick(page + 1)}
      >
        <Icon name="chevron-right" size="sm" />
      </button>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default Pagination;
